<template>
  <p class="form-help">
    <slot/>
  </p>
</template>

<script>
export default {
  name: 'CFormHelp'
}
</script>

<style scoped>
.form-help {
  margin: 0 -2px 10px;
  padding: 0 14px;

  background: var(--color-brand-pale);
  border-radius: 16px;
}
</style>
